import {RouteRecordRaw} from "vue-router";
import {t} from "@/core/i18n";


export const routes: RouteRecordRaw = {
    path: "/analytics-reports",
    name: "analyticsReports",
    redirect: {name: "dailyUsageForMonth"},
    children: [
        {
            path: "/analytics-reports/dailyUsageForMonth",
            name: "dailyUsageForMonth",
            component: () => import("@/modules/AnalyticsReports/pages/DailyUsageForMonth.vue"),
            meta: {
                breadcrumb: [
                    {title: t("analyticsReports"), routeName: "analyticsReports"},
                    {title: t("dailyUsageForMonth"), routeName: "dailyUsageForMonth"},
                ],
            },
        },
        {
            path: "/analytics-reports/hourlyAppUsage",
            name: "hourlyAppUsage",
            component: () => import("@/modules/AnalyticsReports/pages/HourlyAppUsage.vue"),
            meta: {
                breadcrumb: [
                    {title: t("analyticsReports"), routeName: "analyticsReports"},
                    {title: t("hourlyAppUsage"), routeName: "hourlyAppUsage"},
                ],
            },
        },
    ]

}